import React, {useState, useEffect, useRef, useCallback} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import CheckboxField from '@/shared/components/form/CheckboxField';
import { Modal, ModalBody, ModalHeader, Button, ButtonToolbar, Row, Col } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import formValidation from "@/shared/validation/program-awarding";
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import MONTHS from "@/shared/json/months.json";
import {useDispatch, sendFlashMessage} from "@/shared/components/flash";
import axios from 'axios'
import renderSelectField from '@/shared/components/form/Select'
import { getProgramAction } from '@/redux/actions/programActions';
import {isEqual, clone} from 'lodash';
import TooltipPopup from '@/shared/components/form/TooltipPopup';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { BUDGET_INFO_POPUP_DATA } from './BudgetCascadingPopupData';
import HierarchySaveModal from './HierarchySaveModal';
import HierarchySaveDigitalMediaModal from './HierarchySaveDigitalMediaModal';
import { Table } from 'antd';

const prepareForValidation = values => {
    // console.log(values)
    const clean = {
        annual_expire_day: values?.annual_expire_day?.value,
        custom_expire_units: values?.custom_expire_units?.value,
        annual_expire_month: values?.annual_expire_month?.value,
        awarding_manager_id: values?.awarding_manager_id?.value
    }
    return {...values, ...clean}
}


const getMonthLabelByMonth = number => {
    return MONTHS.find( month => month.number === number)?.label
}

const CUSTOM_UNITS = [];
CUSTOM_UNITS.push({label: 'DAY', value: 'DAY'})
CUSTOM_UNITS.push({label: 'MONTH', value: 'MONTH'})
CUSTOM_UNITS.push({label: 'YEAR', value: 'YEAR'})

const AwardingPointsModal = ({dispatch, organization, data, isOpen, setOpen, toggle, theme, rtl}) => {
    const [loading, setLoading] = useState(false)
    const [month, setMonth] = useState(null)
    const [DAYS, setDAYS] = useState([])
    var [data, setData] = useState(data)
    const [programManagersOptions, setProgramManagersOptions] = useState([]);
    const [openTooltipPopup, setTooltipPopup] = useState(null);
    const [isCascadeConfirmOpen, setCascadeConfirmOpen] = useState(false);
    const [activeCascadeField, setActiveCascadeField] = useState(null);

    // ICOV3-1572: fires immediately on an eligible field's own change, not on
    // Save — see ~/.claude-specs/ICOV3_React/ICOV3-1572-specs.md Step 13.
    const handleCascadeFieldChange = (fieldName, newValue) => {
        data[fieldName] = newValue;
        setActiveCascadeField({ name: fieldName, value: newValue });
        setCascadeConfirmOpen(true);
    };
    const [showHierarchyModal, setShowHierarchyModal] = useState(false);
    const [showHierarchyListModal, setShowHierarchyListModal] = useState(false);
    const [hierarchyListData, setHierarchyListData] = useState([]);
    const [checkedState, setCheckedState] = useState([]);
    const [pendingSubmitValues, setPendingSubmitValues] = useState(null);
    const originalManagerId = useRef(null);

    const handleCloseTooltipPopup = () => {
      setTooltipPopup(null);
    };
  
    const handleOpenTooltipPopup = (title) => {
        setTooltipPopup(title);
    };
    
    const setDays = (seletedMonth) => {
        setDAYS([])
        if( typeof seletedMonth !== 'object' || !seletedMonth) return;
        var days = []
        for( var i=1;i<=seletedMonth.days;i++ )  {
            days.push({label:i, value:i});
        }
        setDAYS(days)
    }
    const handleMonthChange = (selectedMonth) => {
        if( typeof selectedMonth !== 'object' || !selectedMonth) return;
        let tmpData = clone(data);
        tmpData.expiration_rule_id = 5;
        tmpData.annual_expire_month = selectedMonth.number;
        setData(tmpData);

        // alert(JSON.stringify(selectedMonth))
        setMonth(selectedMonth)
        setDays(selectedMonth)
    }
    useEffect(() => {
        const fetchManagers = async () => {
            try {
                const res = await axios.get(
                    `/organization/${data.organization_id}/program/${data.id}/managers`
                );

                const options = (res?.data?.managers ?? []).map(manager => ({
                    label: manager?.email,
                    value: manager?.id
                }));
                setProgramManagersOptions(options);

                // Pre-select the effective awarding manager (own or inherited from parent)
                const effectiveId = res?.data?.awarding_manager_id;
                const isInherited = res?.data?.awarding_manager_inherited;

                if (effectiveId) {
                    const match = options.find(o => o.value === effectiveId);
                    if (match) {
                        originalManagerId.current = effectiveId;
                        setData(prev => ({
                            ...prev,
                            awarding_manager_id: match,
                            _awarding_manager_inherited: isInherited
                        }));
                    }
                }

            } catch (error) {
                console.error('Error fetching managers:', error);
            }
        };

        if (data?.organization_id && data?.id) {
            fetchManagers();
        }
    }, [data?.organization_id, data?.id]);
    const doSave = async (prepared) => {
        setLoading(true);
        const payload = {...data, ...prepared};
        delete payload['merchants'];
        delete payload.unknown;
        try {
            const response = await axios.put(`/organization/${payload.organization_id}/program/${payload.id}`, payload);
            setLoading(false);
            if (response.status === 200) {
                dispatch(getProgramAction(payload.organization_id, payload.id));
                dispatch(sendFlashMessage('Program has been updated', 'alert-success', 'top'));
                window.location.reload();
            }
        } catch (e) {
            setLoading(false);
            dispatch(sendFlashMessage('Program could not be updated', 'alert-danger', 'top'));
            throw new Error(`API error:${e?.message}`);
        }
    };

    const onSubmitHierarchy = async () => {
        try {
            const res = await axios.get(`/organization/${data.organization_id}/program/${data.id}/hierarchy-prepare`);
            setHierarchyListData(res.data);
            setCheckedState(res.data.map(item => ({ checked: true, value: item.id })));
            setShowHierarchyModal(false);
            setShowHierarchyListModal(true);
        } catch (e) {
            dispatch(sendFlashMessage('Error loading hierarchy list: ' + e.message, 'alert-danger'));
        }
    };

    const onSubmitHierarchyList = async () => {
        const programIds = checkedState.filter(i => i.checked).map(i => i.value);
        try {
            setLoading(true);
            await axios.put(`/organization/${data.organization_id}/program/${data.id}/update-hierarchy`, {
                organization_id: data.organization_id,
                program_id: data.id,
                programIds,
                awarding_manager_id: pendingSubmitValues?.awarding_manager_id,
            });
            setLoading(false);
            setShowHierarchyListModal(false);
            dispatch(sendFlashMessage('Program hierarchy has been updated', 'alert-success'));
            window.location.reload();
        } catch (e) {
            setLoading(false);
            dispatch(sendFlashMessage('Error updating hierarchy', 'alert-danger'));
        }
    };

    const onSubmitForm = async (values) => {
        const prepared = prepareForValidation(values);
        const newManagerId = prepared?.awarding_manager_id;

        if (newManagerId && newManagerId !== originalManagerId.current) {
            setPendingSubmitValues(prepared);
            setShowHierarchyModal(true);
            return;
        }
        await doSave(prepared);
    };
    // alert(data.annual_expire_day)
    // console.log(data)
    let initialValues = data
    if( typeof initialValues.annual_expire_day !== 'object') {
        const parsedValues = {
            annual_expire_day: {
                label: data.annual_expire_day,
                value: data.annual_expire_day
            },
            annual_expire_month: {
                label: getMonthLabelByMonth(data.annual_expire_month),
                value: data.annual_expire_month
            }
        }
        // alert(data.expiration_rule_id)
        initialValues = {...initialValues, ...parsedValues}
    }
    const hasParent = data?.parent_id !== null && data?.parent_id !== undefined;

    initialValues = {
        ...data,
        deactivate_user_after_days: data.hierarchy?.[0]?.deactivate_user_after_days ?? null
    };

    return (
    <>
    <Modal className={`modal-program modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
        <Form
        onSubmit={onSubmitForm}
        validate={(values) => formValidation.validateForm(prepareForValidation(values))}
        // validate={validate}
        initialValues={initialValues}
        >
        {({ handleSubmit, form, submitting, pristine, values }) => (
        <form className="form" onSubmit={handleSubmit}>
            <ModalHeader className='w100'>
                <Row className='w100'>
                    <Col md="6" lg="6" xl="6">
                        <h3>Awarding and Points</h3>
                        <h5 className="colorgrey">{data.name}</h5>
                    </Col>
                    <Col md="6" lg="6" xl="6" className='text-right'>
                        <ButtonToolbar className="modal__footer flex justify-content-right w100">
                            <Button outline color="primary" className="mr-3" onClick={toggle}>Close</Button>{' '}
                            <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">Save</Button>
                        </ButtonToolbar>
                    </Col>
                </Row>
            </ModalHeader>
            <ModalBody className='modal-lg'>
                <h5 className="thick size16 mb-4">Awarding Settings</h5>
                <Row style={{alignItems:'center'}}>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="events_has_limits"
                                label="Set limit in events"
                                checked={data?.events_has_limits}
                                onChange={() => handleCascadeFieldChange('events_has_limits', !data.events_has_limits)}
                            />
                        </div>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="user_has_to_claim_award"
                                label="User has to claim award"
                                checked={data?.user_has_to_claim_award}
                                onChange={() => handleCascadeFieldChange('user_has_to_claim_award', !data.user_has_to_claim_award)}
                            />
                        </div>
                    </Col>

                    {data.user_has_to_claim_award ? (<Col md="6" lg="4" xl="4">
                        <Field name="user_claim_expire_after_days">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <span style={{ whiteSpace: 'nowrap' }}>Expire after
                                                <input type="number" {...input} min={0} placeholder="X" style={{width:"30%", marginLeft:"12px", marginRight: "12px"}} />days
                                            </span>
                                            <Button
                                                type="button"
                                                color="primary"
                                                size="sm"
                                                className="ml-2"
                                                onClick={() => handleCascadeFieldChange('user_claim_expire_after_days', input.value)}
                                            >
                                                Save
                                            </Button>
                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}

                                        </div>
                                    </div>
                                </div>
                            )}
                        </Field>
                     </Col>
                    ):<></>}

                </Row>
                <Row>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="event_has_category"
                                label="Enable categories for events"
                                checked={data?.event_has_category}
                                onChange={() => handleCascadeFieldChange('event_has_category', !data.event_has_category)}
                            />
                        </div>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="has_promotional_award"
                                label="Enable promotional awards"
                                checked={data?.has_promotional_award}
                                onChange={() => handleCascadeFieldChange('has_promotional_award', !data.has_promotional_award)}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="enable_reference_documents"
                                label="Enable uploading documents while awarding"
                                checked={data?.enable_reference_documents}
                                onChange={() => handleCascadeFieldChange('enable_reference_documents', !data.enable_reference_documents)}
                            />
                        </div>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="enable_schedule_awards"
                                label="Enable scheduled awards"
                                checked={data?.enable_schedule_awards}
                                onChange={() => handleCascadeFieldChange('enable_schedule_awards', !data.enable_schedule_awards)}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="4" xl="4">
                      <div className='d-flex'>
                        <CheckboxField
                          name="schedule_awards_required"
                          label="Schedule Awards Required"
                          checked={data.schedule_awards_required}
                          onChange={() => handleCascadeFieldChange('schedule_awards_required', !data.schedule_awards_required)}
                        />
                        <TooltipPopup openTooltipPopup={openTooltipPopup} handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() => handleOpenTooltipPopup("schedule_awards_required")} title="schedule_awards_required"
                          text={BUDGET_INFO_POPUP_DATA.scheduleDate}>
                          <span className="ml-2"><HelpOutlineIcon fontSize='small' /></span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="allow_awarding_pending_activation_participants"
                                label="Allow awarding pending activation participants"
                                checked={data?.allow_awarding_pending_activation_participants}
                                onChange={() => handleCascadeFieldChange('allow_awarding_pending_activation_participants', !data.allow_awarding_pending_activation_participants)}
                            />
                        </div>
                    </Col>
                            </Row>
                            <Row>
                                <Col md="6" lg="4" xl="4">
                                    <div className="form__form-group">
                                        <CheckboxField
                                            name="allow_awarding_pending_deactivation_participants"
                                            label="Allow awarding pending deactivation participants"
                                            checked={data?.allow_awarding_pending_deactivation_participants}
                                            onChange={() => handleCascadeFieldChange('allow_awarding_pending_deactivation_participants', !data.allow_awarding_pending_deactivation_participants)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <div className="form__form-group">
                                        <span className="form__form-group-label">Awarding Manager</span>
                                        <div className="form__form-group-field">
                                            <div className="form__form-group-row">
                                                <Field
                                                    name="awarding_manager_id"
                                                    component={renderSelectField}
                                                    options={programManagersOptions}
                                                    placeholder={'Awarding Manager'}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                <h5 className="thick size16 mb-4">Points Expiration Rules:</h5>
                <Row>
                    <Col md="6" >
                        <Field
                                name="expiration_rule_id"
                                component={renderRadioButtonField}
                                label="End of Next Year"
                                radioValue={Number('3')}
                                value={data.expiration_rule_id}
                                parse={(value) => { handleCascadeFieldChange('expiration_rule_id', value); return value; }}
                            />
                        <h5 className="colorgrey label-margin-left">Expiration date is the end of the following year</h5>
                        <Field
                                name="expiration_rule_id"
                                component={renderRadioButtonField}
                                label="2 Years"
                                radioValue={Number('7')}
                                value={data.expiration_rule_id}
                                parse={(value) => { handleCascadeFieldChange('expiration_rule_id', value); return value; }}
                            />
                        <h5 className="colorgrey label-margin-left">Expiration date is the end of the next following year</h5>
                        <Field
                                name="expiration_rule_id"
                                component={renderRadioButtonField}
                                label="Custom"
                                radioValue={Number('4')}
                                value={data.expiration_rule_id}
                                parse={(value) => { handleCascadeFieldChange('expiration_rule_id', value); return value; }}
                            />
                        <h5 className="colorgrey label-margin-left">Expiration date is user specified</h5>

                        <Row className="label-margin-left">
                            <Col md="6" >
                                <Field name="custom_expire_offset">
                                    {({ input, meta }) => (
                                        <div className="form__form-group">
                                            <span className="form__form-group-label">Custom expiration offset</span>
                                            <div className="form__form-group-field">
                                                <div className="form__form-group-row">
                                                    <input type="number" {...input} placeholder="Custom expiration offset" />
                                                    <Button
                                                        type="button"
                                                        color="primary"
                                                        size="sm"
                                                        className="ml-2"
                                                        onClick={() => handleCascadeFieldChange('custom_expire_offset', input.value)}
                                                    >
                                                        Save
                                                    </Button>
                                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Field>
                            </Col>
                            <Col md="6">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Custom expiration units</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <Field
                                                name="custom_expire_units"
                                                component={renderSelectField}
                                                options={CUSTOM_UNITS}
                                                placeholder={''}
                                                parse={(value) => { handleCascadeFieldChange('custom_expire_units', value?.value); return value; }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Field
                            name="expiration_rule_id"
                            component={renderRadioButtonField}
                            label="Annual"
                            radioValue={Number('5')}
                            value={data.expiration_rule_id}
                            parse={(value) => { handleCascadeFieldChange('expiration_rule_id', value); return value; }}
                        />
                        <h5 className="colorgrey label-margin-left">Expiration date a specified Month and Day each year.</h5>
                        <Row className="label-margin-left">
                            <Col md="6" lg="4" xl="4">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Month</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <Field
                                                name="annual_expire_month"
                                                options={MONTHS}
                                                // onChange={handleMonthChange}
                                                placeholder={"Month"}
                                                component={renderSelectField}
                                                parse={value => {
                                                    handleMonthChange(value)
                                                    handleCascadeFieldChange('annual_expire_month', value?.value)
                                                    return value;
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md="6" lg="4" xl="4">
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Day</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <Field
                                                name="annual_expire_day"
                                                component={renderSelectField}
                                                options={DAYS}
                                                placeholder={'Day'}
                                                parse={(value) => { handleCascadeFieldChange('annual_expire_day', value?.value); return value; }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Col>
                </Row>


                <Row>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField 
                                name="send_points_expire_notices"
                                label="Send points expiration notice"
                                checked={data?.send_points_expire_notices}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="4" xl="4">
                        <Field name="points_expire_notice_days">
                        {({ input, meta }) => (
                            <div className="form__form-group">
                                <span className="form__form-group-label">Notify participant of expiring points by</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                        <input type="text" {...input} placeholder="Notify participant of expiring points by" />
                                        <Button
                                            type="button"
                                            color="primary"
                                            size="sm"
                                            className="ml-2"
                                            onClick={() => handleCascadeFieldChange('points_expire_notice_days', input.value)}
                                        >
                                            Save
                                        </Button>
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            </div>
                        )}
                        </Field>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                        <Field name="factor_valuation">
                            {({ input, meta }) => (
                                <div className="form__form-group">
                                    <span className="form__form-group-label">Factor for points valuation</span>
                                    <div className="form__form-group-field">
                                        <div className="form__form-group-row">
                                            <input type="text" {...input} placeholder="Factor for points validation" />
                                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Field>
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col md="6" lg="4" xl="4">*/}
                {/*        <div className="form__form-group">*/}
                {/*            <CheckboxField */}
                {/*                name="allocate"*/}
                {/*                label="Allocate cost to program for premium merchants"*/}
                {/*                checked={data?.allocate}*/}
                {/*                onChange={() => {data.allocate = !data.allocate}}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                <Row>
                    <Col md="6" lg="4" xl="4">
                        <Field name="amount_override_limit_percent">
                        {({ input, meta }) => (
                            <div className="form__form-group">
                                <span className="form__form-group-label">Amount override percentage</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                        <input type="number" {...input} placeholder="Amount override percentage" />
                                        <Button
                                            type="button"
                                            color="primary"
                                            size="sm"
                                            className="ml-2"
                                            onClick={() => handleCascadeFieldChange('amount_override_limit_percent', input.value)}
                                        >
                                            Save
                                        </Button>
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            </div>
                        )}
                        </Field>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="4" xl="4">
                        <div className="form__form-group">
                            <CheckboxField
                                name="awards_limit_amount_override"
                                label="Limit(prevent) award amount override"
                                checked={data?.awards_limit_amount_override}
                                onChange={() => handleCascadeFieldChange('awards_limit_amount_override', !data.awards_limit_amount_override)}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md="6" lg="4" xl="4">
                        <Field name="point_ratio_seperation">
                        {({ input, meta }) => (
                            <div className="form__form-group">
                                <span className="form__form-group-label">Enter new points ratio</span>
                                <div className="form__form-group-field">
                                    <div className="form__form-group-row">
                                        <input type="number" {...input} placeholder="Enter new points ratio" />
                                        <Button
                                            type="button"
                                            color="primary"
                                            size="sm"
                                            className="ml-2"
                                            onClick={() => handleCascadeFieldChange('point_ratio_seperation', input.value)}
                                        >
                                            Save
                                        </Button>
                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                    </div>
                                </div>
                            </div>
                        )}
                        </Field>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                      <div className='d-flex'>
                        <CheckboxField
                          name="add_referred_as_participant"
                          label="Add referred as Participant"
                          checked={data.add_referred_as_participant}
                          onChange={() => handleCascadeFieldChange('add_referred_as_participant', !data.add_referred_as_participant)}
                        />
                      </div>
                    </Col>
                </Row>
                            <Row>
                                <Col md="6" lg="4" xl="4">
                                    <Field name="deactivate_user_after_days">
                                        {({ input, meta }) => (
                                            <div className="form__form-group">
                                                <span className="form__form-group-label">Deactivate user after</span>
                                                <div className="form__form-group-field">
                                                    <div className="form__form-group-row">
                                                        <input type="number" {...input} placeholder="Deactivate user after" disabled={hasParent} />
                                                        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Field>
                                </Col>
                            </Row> 
            </ModalBody>
        </form>
        )}
        </Form>
    </Modal>
    <HierarchySaveModal
      isOpen={isCascadeConfirmOpen}
      toggle={() => setCascadeConfirmOpen(false)}
      organizationId={data.organization_id}
      programId={data.id}
      settingsGroup="awarding"
      fields={activeCascadeField ? { [activeCascadeField.name]: activeCascadeField.value } : {}}
      dispatch={dispatch}
      onSuccess={() => {
        dispatch(getProgramAction(data.organization_id, data.id));
        setActiveCascadeField(null);
      }}
    />

    <HierarchySaveDigitalMediaModal
        isOpen={showHierarchyModal}
        toggle={() => setShowHierarchyModal(false)}
        onSubmit={() => doSave(pendingSubmitValues)}
        onSubmitHierarchy={onSubmitHierarchy}
    />

    <Modal className="modal-event-hierarchy-list modal-lg" isOpen={showHierarchyListModal} toggle={() => setShowHierarchyListModal(false)}>
        <ModalHeader>
            <div>Please select the programs that you wish to update the Awarding Manager for</div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: 'left' }}>
            <div style={{ padding: '10px' }}>
                <Button outline className="btn btn-primary btn-sm" color="#ffffff" onClick={onSubmitHierarchyList} disabled={loading}>
                    Save
                </Button>
            </div>
            <Table
                pagination={false}
                rowKey="id"
                dataSource={hierarchyListData}
                columns={[
                    { title: 'Program ID', dataIndex: 'id', key: 'id' },
                    { title: 'Program Name', dataIndex: 'name', key: 'name' },
                    {
                        title: 'Update?',
                        key: 'action',
                        render: (_, record, index) => (
                            <input
                                type="checkbox"
                                checked={checkedState[index]?.checked ?? true}
                                onChange={() => {
                                    const tmp = [...checkedState];
                                    tmp[index] = { ...tmp[index], checked: !tmp[index].checked };
                                    setCheckedState(tmp);
                                }}
                            />
                        ),
                    },
                ]}
            />
        </ModalBody>
    </Modal>
    </>
    )
}
AwardingPointsModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  organization: Object.isRequired,
  data: Object.isRequired
};

export default withRouter(connect((state) => ({
  theme: state.theme,
  rtl: state.rtl,
  organization: state.organization,
  data: state.program
}))(AwardingPointsModal));
